import React, { useId, useState } from "react";

const UploadDocument = ({
  label = "Upload Document",
  onChange,
  existingFile = null,
  selectedFile = null,
  maxSizeMB = 10,
  disabled = false,
}) => {
  const inputId = useId();
  const [error, setError] = useState("");

  const allowedTypes = [
    "application/pdf",
    "text/csv",
    "application/vnd.ms-excel",
  ];

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setError("");

    if (!allowedTypes.includes(file.type)) {
      setError("Only PDF and CSV files are allowed");
      e.target.value = "";
      return;
    }

    const maxSize = maxSizeMB * 1024 * 1024;
    if (file.size > maxSize) {
      setError(`File must be less than ${maxSizeMB}MB`);
      e.target.value = "";
      return;
    }

    onChange(file);
    e.target.value = "";
  };

  const getFileName = (file) => {
    if (!file) return "";
    if (typeof file === "string") return file.split("/").pop();
    if (file?.name) return file.name;
    return "File";
  };

  return (
    <div
      style={{
        border: "1px dashed #ccc",
        padding: 12,
        borderRadius: 8,
        opacity: disabled ? 0.7 : 1,
      }}
    >
      <p style={{ display: "block", marginBottom: 8, marginTop: 0 }}>{label}</p>

      <input
        id={inputId}
        type="file"
        onChange={handleFileChange}
        style={{ display: "none" }}
        accept=".pdf,.csv"
        disabled={disabled}
      />

      {!disabled && (
        <label
          htmlFor={inputId}
          style={{
            display: "inline-block",
            padding: "8px 14px",
            borderRadius: 8,
            border: "1px solid #5C308D",
            background: "#f9f5ff",
            color: "#5C308D",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Choose File
        </label>
      )}

      {existingFile && typeof existingFile === "string" && !selectedFile && (
        <div style={{ marginTop: 10, fontSize: 13, color: "#555" }}>
          Current: {getFileName(existingFile)}
        </div>
      )}

      {selectedFile && (
        <div
          style={{
            marginTop: 10,
            fontSize: 13,
            color: "#5C308D",
            fontWeight: 600,
          }}
        >
          Selected: {getFileName(selectedFile)}
        </div>
      )}

      {error && (
        <div style={{ color: "red", marginTop: 8, fontSize: 12 }}>{error}</div>
      )}
    </div>
  );
};

export default UploadDocument;
